export const getMemberDetailsSelectedUserId = (state) => state.memberDetails.selectedUserId;
export const getMemberDetailsSelectedChannelId = (state) => state.memberDetails.selectedChannelId;
